import { extractData } from '@/common/api/helpers';
import generateActions from '@/common/store/helpers/actions';
const { api } = generateActions('/settings');

export const get = ({ commit }) => {
  return api.get().then(extractData).then(res => res && commit('save', res));
};
